import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { message: String, button: String }

  confirm(event) {
    event.preventDefault()

    const popupElement = document.querySelector(".ajax-bpopup")

    window.$(popupElement).bPopup({
      onOpen: () => this.fillPopupContent(popupElement, this.messageValue, this.element),
      onClose: () => this.clearPopupContent(popupElement)
    })
  }

  translate(key) {
    return (window.i18nHelper && window.i18nHelper.t(key)) || null
  }

  fillPopupContent(container, message, form) {
    container.innerHTML = `
        <div class="bpopup-content sm">
          <div class="tw-space-y-3">
            <p>${message}</p>
          </div>
          <div class="footer flex">
            <a href="#" class="md-btn b-close js-cancel">${window.i18nHelper.t('actions.close')}</a>
            <a href="#" class="md-btn md-blue-btn md-primary-btn js-confirm">${this.buttonValue}</a>
          </div>
        </div>
    `

    container.querySelector(".js-cancel")?.addEventListener("click", (e) => {
      e.preventDefault()
      this.triggerClose(container)
    })

    container.querySelector(".js-confirm")?.addEventListener("click", (e) => {
      e.preventDefault()
      form.requestSubmit()
      this.triggerClose(container)
    })
  }

  clearPopupContent(container) {
    container.innerHTML = ""
    container.style.display = "none"
  }

  triggerClose(container) {
    container.querySelector(".b-close")?.click()
  }
}
